if (!window.glymedProductCardInit) {
  window.glymedProductCardInit = true;
  document.addEventListener('DOMContentLoaded', () => {
    initSwatches();
    if (window.updateGlymedButtonStates) window.updateGlymedButtonStates();
  });
}

function initSwatches() {
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.swatch-item');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    handleSwatchClick(swatch);
  });
}

function handleSwatchClick(swatch) {
  const card = swatch.closest('.card-wrapper');
  if (!card) return;

  const imageSrc = swatch.dataset.image;
  const price = swatch.dataset.price;
  const variantId = swatch.dataset.variantId;

  const available = swatch.dataset.available === 'true';

  const mainImage = card.querySelector('.card__media img');
  if (mainImage && imageSrc) {
    try {
      const imageUrl = new URL(imageSrc, window.location.origin);
      mainImage.srcset = [165, 360, 533, 720, 940, 1066]
        .map((width) => {
          imageUrl.searchParams.set('width', width);
          return `${imageUrl} ${width}w`;
        })
        .join(', ');
    } catch (e) {
      mainImage.removeAttribute('srcset');
    }
    mainImage.src = imageSrc;
  }

  let priceContainer = card.querySelector('.price-item--sale');
  if (!priceContainer) {
    priceContainer = card.querySelector('.price__regular .price-item--regular');
  }

  if (priceContainer && price) {
    priceContainer.textContent = price;
  }

  const allSwatches = card.querySelectorAll('.swatch-item');
  allSwatches.forEach(s => s.classList.remove('is-selected'));
  swatch.classList.add('is-selected');

  const variantInput = card.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.value = variantId;
  }

  const button = card.querySelector('.glymed-cta-button');
  const buttonSpan = button ? button.querySelector('span') : null;

  if (button && buttonSpan) {
    if (available) {
      button.removeAttribute('disabled');
      if (buttonSpan.textContent === (window.variantStrings?.soldOut || 'Sold Out')) {
        buttonSpan.textContent = window.variantStrings?.addToCart || 'Add to Cart';
        button.dataset.originalText = buttonSpan.textContent;
      }
    } else {
      button.setAttribute('disabled', 'disabled');
      buttonSpan.textContent = window.variantStrings?.soldOut || 'Sold Out';
      button.dataset.originalText = buttonSpan.textContent;
    }
  }

  const productLinks = card.querySelectorAll('a[href*="/products/"]');
  productLinks.forEach(link => {
    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    } catch (e) {
      console.error('Error updating link URL:', e);
    }
  });

  if (window.updateGlymedButtonStates) {
    window.updateGlymedButtonStates(false);
  }
}
